// extracted by mini-css-extract-plugin
module.exports = {"component":"categories_component_2ro-C","add":"categories_add_263TG"};